import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import flatten from 'lodash/flatten';
import {
  prepareBaseModuleItemFieldsToSubmit,
  convertBaseModuleItemFieldsToForm,
  convertBaseModuleItemCategoriesToForm,
} from '../../../../common';
import { baseModuleScreens } from '../../../../constants';
import { changeBaseModuleScreen } from '../../../../actions/baseModule';
import {
  updateBaseModuleItem,
  removeBaseModuleItem,
  setCurrentModuleItem,
  receiveNsiProductType,
  getNsiItemDetailFilters,
  saveNsiProductType,
  saveNsiDetailFilters,
  togglePublishBaseModuleItem,
} from '../../../../actions/baseModuleItems';
import BaseModuleItemForm from './BaseModuleItemForm';
import ConfirmationModal from '../../../Modals/ConfirmationModal';
import i18n from '../../../../internationalization/i18n';
import { loadTags } from '../../../../actions/tags';

const propTypes = {
  domain: PropTypes.string,
  currentModule: PropTypes.object.isRequired,
  currentModuleItem: PropTypes.object.isRequired,
  changeBaseModuleScreen: PropTypes.func.isRequired,
  updateBaseModuleItem: PropTypes.func.isRequired,
  removeBaseModuleItem: PropTypes.func.isRequired,
  setCurrentModuleItem: PropTypes.func.isRequired,
  selectableItems: PropTypes.array.isRequired,
  productTypes: PropTypes.array.isRequired,
  receiveNsiProductType: PropTypes.func.isRequired,
  saveNsiProductType: PropTypes.func.isRequired,
  getNsiItemDetailFilters: PropTypes.func.isRequired,
  detailFilters: PropTypes.array.isRequired,
  saveNsiDetailFilters: PropTypes.func.isRequired,
  loadTags: PropTypes.func.isRequired,
  allTags: PropTypes.array,
};

const defaultProps = {
  domain: null,
  allTags: [],
};

class BaseModuleItemEdit extends Component {
  constructor(props) {
    super(props);
    const { title, categories, field_values, route } = props.currentModuleItem;
    this.state = {
      showModal: false,
      initialValues: {
        title,
        categories: convertBaseModuleItemCategoriesToForm(categories),
        fields: convertBaseModuleItemFieldsToForm(field_values),
        tags: route.tags,
        route,
      },
    };
  }

  componentDidMount() {
    this.props.loadTags();

    // custom nsi logic @todo extract it
    if (this.props.domain === 'nsi-be.com') {
      const { id } = this.props.currentModuleItem;
      // custom nsi types
      this.props.receiveNsiProductType(id).then(({ response }) => {
        if (response && response.type) {
          this.setState({
            initialValues: Object.assign({}, this.state.initialValues, { type: response.type.toString() }),
          });
        }
      });

      // custom nsi detail filters
      this.props.getNsiItemDetailFilters(id).then(({ response }) => {
        if (response && response.detailFilters) {
          const detailFilters = {};
          response.detailFilters.forEach((filter) => {
            if (!detailFilters[filter.group.label]) detailFilters[filter.group.label] = [];
            detailFilters[filter.group.label].push(filter.id);
          });
          const productCodes = {};
          response.productCodes.forEach((code) => {
            productCodes[code.detail_filter_ids.split(',').sort((a, b) => a - b).join(',')] = code.code;
          });
          this.setState({
            initialValues: Object.assign({}, this.state.initialValues, { detailFilters, productCodes }),
          });
        }
      });
    }
  }

  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  modalSubmit = () => {
    this.props.removeBaseModuleItem()
      .then(() => {
        this.props.changeBaseModuleScreen(baseModuleScreens.moduleItemsList);
        this.props.setCurrentModuleItem(null);
      });
  };

  handleSubmit = (formValues) => {
    const formBody = { ...formValues };
    const fields = prepareBaseModuleItemFieldsToSubmit(formBody.fields);
    const detailFiltersIds = formBody.detailFilters ? flatten(Object.values(formBody.detailFilters)) : [];
    formBody.fields = fields;
    let productCodes = [];
    if (formBody.productCodes) {
      productCodes = Object.keys(formBody.productCodes).map(key => ({
        detailFilterIds: key.split(','),
        code: formBody.productCodes[key],
      }));
    }

    return this.props.updateBaseModuleItem(formBody)
      .then(() => {
        const { type } = formBody;
        // custom nsi types
        if (type) this.props.saveNsiProductType(this.props.currentModuleItem.id, { type });
        if (detailFiltersIds.length) {
          const detailFilters = {
            baseModuleItemId: this.props.currentModuleItem.id,
            detailFiltersIds,
            productCodes,
          };
          this.props.saveNsiDetailFilters(detailFilters);
        }
        return this.props.changeBaseModuleScreen(baseModuleScreens.moduleItemsList);
      });
  };

  render() {
    const { currentModule, currentModuleItem, selectableItems, productTypes, detailFilters } = this.props;
    const { showModal } = this.state;

    return (
      <div className="c-bb-basemodule c-bb-basemodule__item-edit">
        <div className="c-bb-form">
          <div className="c-bb-form__header">
            <div>
              <button
                type="button"
                className="c-bb-button form-header__btn-remove-item"
                onClick={this.openModal}
              >
                {i18n.t('CONTENT.remove').toUpperCase()}
                <i className="icon-trash" />
              </button>
            </div>
          </div>
          <BaseModuleItemForm
            initialValues={this.state.initialValues}
            currentModule={currentModule}
            selectable={selectableItems}
            onSubmit={this.handleSubmit}
            productTypes={productTypes}
            detailFilters={detailFilters}
            changeScreen={this.props.changeBaseModuleScreen}
            allTags={this.props.allTags}
            route={currentModuleItem.route}
          />
        </div>
        {showModal &&
          <ConfirmationModal
            onClose={this.closeModal}
            onOk={this.modalSubmit}
            onCancel={this.closeModal}
            title={i18n.t('CONTENT.remove').toUpperCase()}
            submitButtonText={i18n.t('CONTENT.remove').toUpperCase()}
            icon="icon-basic_sheet"
          >
            <div style={{ textAlign: 'center' }}>
              {i18n.t('CONTENT.deleteConfirmation')}
            </div>
          </ConfirmationModal>
        }
      </div>
    );
  }
}

BaseModuleItemEdit.propTypes = propTypes;
BaseModuleItemEdit.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const {
    baseModule: {
      isOpen,
      currentModule,
      currentModule: {
        categories,
      },
    },
    baseModuleItems: {
      currentItem,
    },
    global: {
      tags,
      websiteSettings: {
        domain,
      },
    },
  } = state;

  let productTypes = [];
  let detailFilters = [];

  if (currentModule && currentModule.internal_name === 'product') {
    productTypes = state.baseModuleItems.customProductTypes;
    detailFilters = state.baseModuleItems.customDetailFilters;
  }

  return {
    isOpen,
    domain,
    currentModule,
    currentModuleItem: currentItem,
    selectableItems: categories,
    productTypes,
    detailFilters,
    allTags: tags,
  };
};

const mapDispatchToProps = {
  changeBaseModuleScreen,
  updateBaseModuleItem,
  removeBaseModuleItem,
  setCurrentModuleItem,
  receiveNsiProductType,
  saveNsiProductType,
  getNsiItemDetailFilters,
  saveNsiDetailFilters,
  togglePublishBaseModuleItem,
  loadTags,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleItemEdit));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemEdit/BaseModuleItemEdit.js